(() => {
  const button = document.querySelector('[data-monsga-back-to-top]');
  if (!button) return;

  const scrollContainer = document.querySelector('.page-wrapper');
  const getScrollTop = () => Math.max(
    scrollContainer?.scrollTop || 0,
    window.scrollY || 0,
    window.pageYOffset || 0,
    document.scrollingElement?.scrollTop || 0,
    document.documentElement?.scrollTop || 0,
    document.body?.scrollTop || 0
  );

  const update = () => {
    const visible = getScrollTop() > Math.max(96, window.innerHeight * 0.12);
    button.hidden = !visible;
    button.toggleAttribute('data-visible', visible);
  };

  button.addEventListener('click', () => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    scrollContainer?.scrollTo({ top: 0, behavior });
    window.scrollTo({ top: 0, behavior });
  });
  window.addEventListener('scroll', update, { passive: true });
  scrollContainer?.addEventListener('scroll', update, { passive: true });
  scrollContainer?.addEventListener('scrollend', update, { passive: true });
  update();
})();
